/* 
// jQuery: initPagedTabbedContent
// Tabbed Content is used for the display of slideshow, tab and photoviewer like content that needs to be pageinated
// Clicking on a page control perfoms some animation and then manipulates a set of tab control content to display
// Clicking on a tab control performs some animation and then manipulates a set of tab content to display
*/

jQuery(function initPagedTabbedContent($) {
	$('.js-rd-paged-tabbed-content-container').each(function(index, el) {

		// Containers and Tab Containers
		var $container            = $(this);
		var $tabsContainer        = $container.find('.js-custom-tabs');
		var $tabs                 = $container.find('.js-tab-content');
		var $pagesContainer       = $container.find('.js-pages');
		var $pages                = $container.find('.js-page-content');
		var $prevControl          = $container.find('.control-prev');
		var $nextControl          = $container.find('.control-next');

		// Thumbnail Image Control
		var $controls             = $container.find('.js-tab-control');
		var currTabIndex          = 0;
		var numTabs               = $tabs.length;
		var maxTabIndex           = $tabs.length - 1;
		var $tabsPerPage 		  = 8;
		
		// Index Management Variables
		var currParseIndex        = 0;
		var numParses             = $pages.length;
		var maxParseIndex         = $pages.length - 1;
		var currentPage 		  = 0;	

		// Page Control
		var $pageControls         = $container.find('.js-page-control');
		var currPageIndex         = 0;
		var numPages              = $tabs.length / $tabsPerPage;
		var maxPageIndex          = ($tabs.length / $tabsPerPage) - 1;

		// Miscellaneous variables
		var isTransitioning       = false;
		var fadeParameters        = {duration: 500, queue: false};
		var autoTabTransitionTime = 6000;
		var automateTabs          = '';

		var initializeWidget = function() {
			// Remove all but the first tab element from the DOM
			$tabs.each(function(index, el) {
				// if (index > 0) { $(this).detach(); }
				if (index > 0) { $(this).addClass("hidden"); }
			});

			// Remove all but the first page element from the DOM
			$pages.each(function(index, el) {
				if (index > 0) { $(this).addClass("hidden"); }
			});

			if(numTabs < 9){
				$('.js-page-control').each(function(index, el) {
					$(this).addClass('hidden-control');
				});
			}

			// Initialize the set of controls
			$($controls[0]).addClass('current');

			// Create click events for all tab controls

			$controls.each(function(index, el) {
				var tabIndex = index;
				$(this).click(function(event) {
					transitionPreviousTab(tabIndex, true);
				});
			});
			
			// Create click event for Previous Control
			$prevControl.each(function(index, el) {
				$(this).click(function(event) {
					transitionPreviousContent('prev', true);
				});
			});

			// Create click event for Previous Control
			$nextControl.each(function(index, el) {
				$(this).click(function(event) {
					transitionNextContent(true);
				});
			});

		};

		var transitionPreviousPage = function(pageIndex, autoPlaySwitch) {

			if(pageIndex < 0){
				pageIndex = maxParseIndex;
			}

			if (!isTransitioning && pageIndex !== currentPage) {
				
				// If the user has clicked a control for a specific tab, disable the autoPlay
				if (autoPlaySwitch) {
					stopAutoplay();
				}
	
				isTransitioning = true;
				var currPage  = $($pages[currPageIndex]);
				
				currPage.fadeOut($.extend(fadeParameters, {
					complete: function() {
						// currPage.detach();
						currPage.addClass("hidden");
						transitionNewPage(pageIndex);
						currentPage = pageIndex;
					}
				}));
			}
		};

		var transitionNewPage = function(pageIndex) {

			var newPage = $($pages[pageIndex]);
			// newPage.appendTo($pagesContainer).hide();
			newPage.removeClass("hidden").hide();
			updatePageControls(pageIndex);

			newPage.fadeIn($.extend(fadeParameters, {
				complete: function() {
					currPageIndex = pageIndex;
					isTransitioning = false;
				}
			}));
		};

		/* Handle the forward / next buttons */

		var transitionPreviousContent = function(direction, autoPlaySwitch) {
			
			if (autoPlaySwitch) {
				stopAutoplay();
			}

			transitionPreviousPage(currentPage - 1, true);

		};

		var transitionNextContent = function(autoPlaySwitch) {

			if (autoPlaySwitch) {
				stopAutoplay();
			}

			var nextPage = currentPage + 1;

			if(nextPage > maxParseIndex){
				nextPage = 0;
			}

			transitionPreviousPage(nextPage);
		};

		var transitionPreviousTab = function(tabIndex, autoPlaySwitch) {
			if (!isTransitioning && tabIndex !== currTabIndex) {
				
				// If the user has clicked a control for a specific tab, disable the autoPlay
				if (autoPlaySwitch) {
					stopAutoplay();
				}
	
				isTransitioning = true;
				var currTab  = $($tabs[currTabIndex]);
				
				currTab.fadeOut($.extend(fadeParameters, {
					complete: function() {
						// currTab.detach();
						currTab.addClass("hidden");
						transitionNewTab(tabIndex);
					}
				}));
			}
		};

		var transitionNewTab = function(tabIndex) {
			var newTab = $($tabs[tabIndex]);
			//newTab.appendTo($tabsContainer).hide();
			newTab.removeClass("hidden").hide();
			updateControls(tabIndex, newTab);
		};

		var updateControls = function(tabIndex, newTab) {
			// Turn off the previous tab control
			$($controls[currTabIndex]).removeClass('current');

			// Check if the new tab control is on a new page
			var newPageIndex = Math.floor(tabIndex / $tabsPerPage);

			// If the new tab control is on a different page, transition the page first
			if (newPageIndex !== currPageIndex) {
				// Turn the transitioning flag off so the new animation can begin
				isTransitioning = false;

				transitionPreviousPage(newPageIndex,false);
			}

			// Turn on the new tab control
			$($controls[tabIndex]).addClass('current');

			newTab.fadeIn($.extend(fadeParameters, {
				complete: function() {
					currTabIndex = tabIndex;
					isTransitioning = false;
				}
			}));
		};

		var updatePageControls = function(pageIndex) {
			// Turn off the previous page control
			$($pageControls[currPageIndex]).removeClass('current');

			// Turn on the new page control
			$($pageControls[pageIndex]).addClass('current');
		};

		var startAutoplay = function() {
			automateTabs = setInterval(tabTimer, autoTabTransitionTime);
		};

		var stopAutoplay = function() {
			clearInterval(automateTabs);
		};

		var tabTimer = function() {
			if (currTabIndex >= maxTabIndex) {
				transitionPreviousTab(0, false);
			} else {
				transitionPreviousTab(currTabIndex + 1, false);
			}
		};

		if (numTabs > 0) {
			initializeWidget();

			if (numTabs > 1) {
				startAutoplay();
			}
		}
	});
});